<template>
  <div class="w-100 d-flex">
    <b-input
      v-model="innerModel"
      type="text"
      class="form-control w-75"
      :disabled="true"
    ></b-input>
    <b-button
      variant="primary"
      class="w-25"
      @click="openModal"
      :disabled="this.schema.disabled"
    >
      Выбрать
    </b-button>
  </div>
</template>

<script lang="ts">
import { Component, Mixins, Watch } from 'vue-property-decorator'
import { abstractField, GenField } from '@it/vue-form-generator'

@Component
export default class ModalOpenInput extends Mixins(abstractField) {
  schema!: GenField

  private innerModel: any = 'dffd'
  private value: any

  private created() {
    if (this.value) {
      this.innerModel = `Прекратил действие с ${this.value}`
    } else {
      this.innerModel = 'Действует'
    }
  }

  @Watch('value')
  private onValueChanged() {
    if (this.value) {
      this.innerModel = `Прекратил действие с ${this.value}`
    } else {
      this.innerModel = 'Действует'
    }
  }

  private openModal() {
    this.$bvModal.show(this.schema.modalId)
  }

  private formatter() {
    return 'действует'
    // if(value) {
    //   return `Прекратил действие с: ${value.toLocaleDateString()}`
    // } else {
    //   return 'Действует'
    // }
  }
}
</script>
